<template>
  <div class="source-content-tabs">
    <ul class="tabs">
      <router-link
        tag="li"
        :to="{ name: 'graphics' }"
        data-entity="producer-assets-showTemplates"
      >
        Templates
      </router-link>

      <router-link
        tag="li"
        :to="{ name: 'saved-graphics' }"
        data-entity="producer-assets-showSavedGraphics"
      >
        <span class="icon icon-saved margin-right-xxs" />
        Saved graphics
      </router-link>
    </ul>

    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>
